export const environment = {
  production: false,
  envSuffix: ' ┃ DEV',
  redirectUri: 'https://checklist.dev.sla-outbound-kd.devtest.gf.aws.scania.com/',
  urlApi: 'https://checklist-api.dev.sla-outbound-kd.devtest.gf.aws.scania.com/',
};
